import axios from 'axios';
import Auth from './auth';
import { API_ROOT } from './apiConfig';


export default class TxCrossmapDataAccess {

    getPASSystems() {
        const auth = new Auth();

        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "zuludatabase", command: "SP_EOM_TxCrossmap_Filters", parameters: { systemId: "" }
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    sessionStorage.setItem('txCrossSystemList', JSON.stringify(response.data));
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                    console.log("here fail");
                });
        });
    }

    getClientsBySystem(systemId) {
        const auth = new Auth();

        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "zuludatabase", command: "SP_EOM_TxCrossmap_Filters", parameters: { systemId: systemId }
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    sessionStorage.setItem('txCrossClientList', JSON.stringify(response.data));
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }

    getFilteredData(pas, fid) {
        const auth = new Auth();

        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "zuludatabase", command: "SP_EOM_TxCrossmap_Data", parameters: { PAS: pas, FID: fid }
            };

            axios.post(`${API_ROOT}/api/v1/qtype/Query`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }

    processTransactionCrossmap(Rows) {
        const auth = new Auth();

        return new Promise((resolve, reject) => {

            let reqBody = {
                account: "zuludatabase", command: "SP_EOM_TxCrossmap_Process", currentUser: auth.getUserEmail(), Rows
            };

            axios.post(`${API_ROOT}/api/v1/Crossmap/TxCrossmapProcess`, reqBody,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${auth.getToken()}`
                    }
                }).then(function (response) {
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }
}
